import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getAnonymousId, getMyBookingsUrl } from 'modules/meta/selectors';
import { showWeb2AppPopupOverlay } from 'modules/overlay/actions';
import { DropDownMenuLink } from '@daedalus/atlas/DropDownMenu';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { getClosestDataIdToEventTarget } from '@daedalus/core/src/_web/utils/browser';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Page } from '@daedalus/core/src/analytics/types/Events';
import { TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY } from '@daedalus/core/src/auth/modules/actions';
import { getUser, selectIsAuthenticated, selectIsLoading } from '@daedalus/core/src/auth/modules/selectors';
import { AuthenticationFlows, ShowPasswordlessLoginPayload } from '@daedalus/core/src/auth/types/Auth';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { isReactNativeWebView } from '@daedalus/core/src/native';
import { useLogIn } from '@daedalus/shared/src/authentication/hooks/useLogIn';
import { useLogOut } from '@daedalus/shared/src/authentication/hooks/useLogOut';
import { HeaderUserWidget as UserWidgetComponent } from '@daedalus/shared/src/user/account/HeaderUserWidget';
const GetTheAppLink = /*#__PURE__*/styled('span')({
  name: "GetTheAppLink",
  class: "g10zdllz",
  propsAsIs: false
});
interface Props {
  page?: Page;
}
const UserWidget = ({
  page
}: Props) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const logIn = useLogIn();
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(getUser);
  const logOut = useLogOut();
  const dispatch = useDispatch();
  const anonymousId = useSelector(getAnonymousId);
  const myBookingsUrl = useSelector(getMyBookingsUrl);
  const {
    brandIsVio
  } = useBrand();
  const isWebView = isReactNativeWebView();
  const shouldShowAppSlot = useMemo(() => brandIsVio && !isWebView, [brandIsVio, isWebView]);
  const handleOnSignIn = ({
    sourceComponent,
    flow
  }: {
    sourceComponent: ShowPasswordlessLoginPayload['sourceComponent'];
    flow: AuthenticationFlows;
  }) => {
    setTimeout(() => logIn({
      sourceComponent,
      anonymousId,
      flow
    }), TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY);
  };
  const openGetTheAppPopup = (event: React.MouseEvent) => {
    event.preventDefault();
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.AppInstallLink,
      action: Action.Clicked,
      payload: {
        selectedElement: getClosestDataIdToEventTarget(event)
      }
    }));
    dispatch(showWeb2AppPopupOverlay({
      placement: Placement.MenuItem
    }));
  };
  if (isLoading) return null;
  return <UserWidgetComponent accountUrl="/user/account" alertsUrl="/user/alerts" logOut={logOut} isAuthenticated={Boolean(isAuthenticated)} user={user} myBookingsUrl={brandIsVio && myBookingsUrl // Don't send the myBookingsUrl when the brand is not Vio, so that the option doesn't render and we don't send customer from other white labels to Vio
  } onSignIn={handleOnSignIn} getTheAppSlot={shouldShowAppSlot && <DropDownMenuLink dataId="desktop_account_drop_down" onClick={openGetTheAppPopup}>
            <GetTheAppLink>
              <FormattedMessageWrapper id="appBanner.button" defaultMessage="Get the app" />
            </GetTheAppLink>
          </DropDownMenuLink>} page={page} />;
};
export default UserWidget;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");